import Dialog from '@mui/material/Dialog';
import useCheckMobileScreen from '../../utils/detect-mobile-size';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import IAllergy from '../../interfaces/IAllergy';

export default function ProductInformationModal(props: any) {
    const {onClose, selectedValue, open, product} = props;

    let isMobile = useCheckMobileScreen();

    const handleClose = () => {
        onClose(selectedValue);
    };

    return (
        <Dialog maxWidth={'xs'} PaperProps={{style: {borderRadius: !isMobile ? '1.5rem' : '', border: '1px solid #09382b'}}} fullScreen={isMobile}
                onClose={handleClose} open={open} fullWidth={true}>
            <DialogTitle>Productinformatie
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <div className="flex flex-col h-full pb-8 pt-2">
                    <ul className="pl-5 list-disc">
                        {product.allergies.map((al: IAllergy) =>
                            <li key={al.id}>{al.name}</li>
                        )}
                    </ul>
                    <p className="text-sm pt-4 text-gray-500">
                        Bovenstaand zijn alle allergenen die gelden voor het desbetreffende product.
                        Voor eventuele extra informatie hierover, aarzel niet contact op te nemen.
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    )
}